import React, { useState } from 'react';
import Stylesheet from './Refference.module.css';
import { AppContext } from '../../../../contexts/app';
import { Link } from 'react-router-dom';
import Button from '../../../../elements/Button/Button';
import Selector from '../../components/Selector/Selector';
import { ico_check, ico_times } from '../../../../icon';
import { updateRecord } from '../../Table.Engine';
/**
 * Table Refference Selector
 */
const Form = (props) => {
    const app = props.app;
    const table = props.table;
    const config = props.config;
    const record = props.record;
    const column = props.column;
    const [records, setRecords] = useState(null);
    const update = _ => {
        if (!records) {
            app.toggleToast(ico_times, 
            "please select 1 or more records to refference", true)
        } else {
            // update record value
            record[column.name] = records;
            // update record document
            updateRecord(record.id, record, table, config)
            .then(_ => app.toggleToast(ico_check, "refferences added"))
        }
    }
    return (
        <form className={Stylesheet.Form} onSubmit={event => {
            event.preventDefault(); update(); }}>
            <h5>select record to refference</h5>
            <Selector group={column.configuration.group} 
            collection={column.configuration.collection} 
            onChange={values => setRecords(values)} 
            defaultValue={record[column.name]} />
            <div className={Stylesheet.Controls}>
                <div className={Stylesheet.Control}>
                    <Button primary type='submit'>
                    confirm</Button>
                </div>
            </div>
        </form>
    )
}

const Refference = (props) => {
    let app = null;
    const column = props.column;
    const configuration = column.configuration;
    const table = props.table;
    const config = props.config;
    const record = props.record;
    const init = appContext => {app = appContext}
    const update = _ => {
        app.toggleModal(null, 
        <Form column={column} table={table}
        record={record} app={app} config={config}
        defaultValue={props.defaultValue}/> ,
        `update refference`);
    }
    return (
        <AppContext.Consumer>
            {app => (
                <div className={Stylesheet.Container}>
                    {init(app)}
                    <div className={Stylesheet.Value}>
                        {props.defaultValue === "NAN"
                        ? <h5>{props.defaultValue}</h5>
                        : <Link to={`/${configuration.refference}?search=${props.defaultValue}`}>
                        {props.defaultValue}</Link>}
                    </div>
                    <div className={Stylesheet.Input}>
                        <Button onClick={update} secondary>
                            update
                        </Button>
                    </div>
                </div>
            )}
        </AppContext.Consumer>
    )
}

export default Refference;